import { currentEnv } from '../env';
export const Statistics = {
  onEvent: function(label, desc, __params = {}) {
    const evtEnum = label || 'DEFAULT';
    const description = desc || '缺省描述';

    try {
      deploy_env = window.DEPLOY_ENV;
    } catch (err) {}
    // 合并并且获取浏览器信息
    const params = Object.assign({}, __params, {
      ua: navigator.userAgent,
      timing: performance.timing,
      env: currentEnv()
    });
    let fn = () => {};
    if (window.TDAPP) {
      fn = window.TDAPP.onEvent
    }
    return fn.apply(window.TDAPP || this, [
      evtEnum,
      description,
      params
    ])
  }
}
export const navigationStart = function() {
  const __timeout = setTimeout(function() {
    clearTimeout(__timeout);
    const timing = window.performance.timing;
    const start = timing.navigationStart;
    const timingObj = {
      // dnsTime
      DNS解析时间: timing.domainLookupEnd - timing.domainLookupStart,
      // tcpTime
      TCP建立时间: timing.connectEnd - timing.connectStart,
      // domReadyTime
      解析DOM树耗时: timing.domComplete - timing.domInteractive,
      // firstPaintTime
      首屏时间: timing.responseStart - start,
      // domRenderTime
      dom渲染完成时间: timing.domContentLoadedEventEnd - start,
      // loadTime
      页面onload时间: timing.loadEventEnd - start
    }

    Object.keys(timingObj).forEach(function(key) {
      timingObj[key] = timingObj[key] + '毫秒'
    });
    Statistics.onEvent('mobile-h5', 'init', timingObj);
    return timingObj
  }, 3000);
}